export default __webpack_public_path__ + "static/media/doc.9a6305cd.svg";